// import moment from "moment";
import { POST, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function obtenerInfoWorkflow(obj) {
    try {
        let result = { error: true };
        const { code, body } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/workflow/obtener-info-workflow",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            result.error = false;
            result.data = body;
        }
        return result;
    } catch (err) {
        console.log("obtenerInfoWorkflow err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function actualizarWorkflowEnServer(obj) {
    try {
        let result = { error: true };
        const { code, body } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/workflow/actualizar-tupla-detalle-pago",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            result.error = false;
            result.data = body;
        }
        return result;
    } catch (err) {
        console.log("obtenerInfoWorkflow err");
        console.log(err);
        return { error: true, message: err };
    }
}